import { Injectable } from '@angular/core';

import { ISdFormComponentItem } from '@seb/web-design-system/core';
import { ICategory } from '@seb/web-design-system/faqs';

import { FaqEntry, FaqJsonLd, FaqNotUsefulReason } from '../models';

@Injectable({
  providedIn: 'root'
})
export class FAQMapper {
  toCategories(entries: FaqEntry[]): ICategory[] {
    const themes: { [code: string]: ICategory } = {};
    entries?.forEach((entry, index) => {
      if (!themes[entry.theme.code]) {
        themes[entry.theme.code] = { title: entry.theme.name, titleLevel: 4, questions: [] };
      }
      themes[entry.theme.code].questions.push({
        id: index.toString(),
        question: entry.question,
        answer: entry.response
      });
    });
    return Object.values(themes);
  }

  toAnswerReasons(reasons: FaqNotUsefulReason[]): ISdFormComponentItem[] {
    return reasons.map((reason) => ({ value: reason.code, libelle: reason.name }));
  }

  toJsonLdFaqs(entries: FaqEntry[]): FaqJsonLd | undefined {
    if (!entries?.length) {
      return undefined;
    }

    const filteredFAQs = entries
      .filter((entry) => {
        const mediaPatterns = [
          /<img\b/i,
          /<video\b/i,
          /<iframe\b/i
        ];
        const hasMedia = mediaPatterns.some((pattern) => pattern.test(entry.response));
        return !(entry.isFaqMedia || entry.media || hasMedia);
      })
      .map((entry) => {
        return {
          '@type': 'Question',
          name: entry.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: entry.response
          }
        };
      });

    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: filteredFAQs
    };

    return jsonLd;
  }
}
